export default __webpack_public_path__ + "static/media/EricaFuResume.9cb4dedc.pdf";